import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardExpandToggler, CardHeader } from '../components/card/card'
import Chart from "react-apexcharts";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DateTime from "react-datetime";
import CardCount from './Summary/CardCount';
import Bar from './Summary/Bar';
import Line from './Summary/Line';
import findItem from '../helperFindPath';
import { getRoleModuleById } from '../redux/action/roleModuleAction';
import { useDispatch, useSelector } from 'react-redux';
import { getSitesById } from '../redux/action/sitesAction';

const SummaryJPO = () => {
    // const [statsBar, setStatsBar] = useState();
    // const [lineChartOptions, setLineChartOptions] = useState(
    //     getLineChartOptions()
    //   );
    const navigate = useNavigate();
	
      function handleBackBtn() {
        navigate(-1);
      }
  const { dataSites, state, dataByIdSites, isModal } = useSelector( (state) => state.sites );
  // console.log(dataByIdSites)      
  const { user } = useSelector((state) => state.auth)
  let { siteId } = useParams()
	const param = { 
		token: user.access_token,
	} 
	const dispatch = useDispatch();
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const pathname = '/dashboard'
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    dispatch(getSitesById({ token: param.token, id: siteId }));
  }, []);
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }
    }
  },[dataRoleModuleSidebar])

  if(dataByIdRoleModule !== ''){

    if(!dataByIdRoleModule.create && !dataByIdRoleModule.read && !dataByIdRoleModule.update && !dataByIdRoleModule.delete){
      return (
        <div>
          <h2>403: Forbidden</h2>
          <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
        </div>
      )
    }else{
  return (
    <div>
        <h4>
        <button onClick={handleBackBtn} className="btn px-3 rounded-pill">
          <i className="fa fa-reply me-1 ms-n1"></i></button> 
          &nbsp; 
          SUMMARY JPO {dataByIdSites.siteName}
        </h4>
        <div className="row">
              <CardCount />
              <Line />
              <Bar />
        </div>
    </div>
  )

  }
  }
  return (
  <div>
    <h2>403: Forbidden</h2>
    <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
  </div>
  )
}

export default SummaryJPO


{/* {statsBar &&
          statsBar.length > 0 &&
          statsBar.map((stat, index) => (
            <div className="col-xl-12 col-lg-12" style={{ paddingTop: '20px'}} key={index}>
              <Card className="mb-3">
              <CardHeader> 
              <div className="row">
                <div className="col-xl-8 col-lg-12">
                  <span className="flex-grow-1 fs-15px"> 
                      {stat.title}
                  </span>
                </div>            
              </div>
            </CardHeader>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3" style={{ textAlign: 'right', alignSelf: 'center' }} > 
                    <div className="col-xl-7 col-lg-12"> </div>
                    <div className="col-xl-2 col-lg-12" style={{ paddingRight: "10px"}}>
                      <DateTime
                        inputProps={{ placeholder: "Start Date" }}
                        closeOnSelect={true}
                      />
                    </div>
                    <div className="col-xl-2 col-lg-12" style={{ paddingRight: "5px"}}>
                      <DateTime
                        inputProps={{ placeholder: "End Date" }}
                        closeOnSelect={true}
                      />
                    </div>
                    <div className="col-xl-1 col-lg-12" style={{ alignSelf: 'center', }}>
                      <CardExpandToggler />
                    </div> 
                  </div>
                  <div className="ratio ratio-21x9 mb-3">
                    <Chart
                      type="bar"
                      stacked="true"
                      height="100%"
                      options={stat.options}
                      series={stat.series}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          ))} */}